import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTenantStore } from '@/store/tenantStore'

// LC 페이지 타이틀 매핑
const PAGE_TITLES: Record<string, string> = {
  '/admin': '대시보드',
  '/admin/classes': '클래스 관리',
  '/admin/calendar': '클래스 일정',
  '/admin/members': '학생 관리',
  '/admin/coaching': '오늘 코칭',
  '/admin/products': '상품 관리',
  '/admin/reports': '학습 현황',
  '/admin/library': '자료실',
  '/my/courses': '내 강의',
  '/login': '로그인',
  '/register': '회원가입',
}

// 동적 라우트 패턴
const DYNAMIC_PATTERNS: Array<{ pattern: RegExp; title: string }> = [
  { pattern: /^\/admin\/products\/\d+$/, title: '상품 상세' },
  { pattern: /^\/admin\/coaching\/\d+$/, title: '학습자 학습내역' },
  { pattern: /^\/learn\/\d+$/, title: '학습 플레이어' },
]

export function usePageTitle(customTitle?: string): void {
  const location = useLocation()
  const { tenantInfo } = useTenantStore()

  useEffect(() => {
    let pageTitle: string | undefined = customTitle

    if (!pageTitle) {
      // 정확한 경로 매칭
      pageTitle = PAGE_TITLES[location.pathname]

      // 동적 패턴 매칭
      if (!pageTitle) {
        const matched = DYNAMIC_PATTERNS.find(({ pattern }) =>
          pattern.test(location.pathname)
        )
        if (matched) pageTitle = matched.title
      }
    }

    // Title is set once in main.tsx to window.location.host
  }, [location.pathname, customTitle, tenantInfo])
}
